import React from 'react';

import { SearchAllContentHit } from '../../types';
import SearchKitResult from '../../../Search/Result';
import './style.scss';

export interface SearchAllContentResultsHitProps {
  hit: SearchAllContentHit;
}

const SearchAllContentResultsHit: React.FC<SearchAllContentResultsHitProps> = (props) => {
  const { hit } = props;

  return (
    <SearchKitResult hit={hit} />
  );
};

export default SearchAllContentResultsHit;
